import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import EntityIdentifier from '@/models/Shared/EntityIdentifier';

export default class Card extends BaseInstitutionEntity {
    accountId: string;
    personIdentifier: EntityIdentifier;  // UX only
    walletId: string;
    personId: string; // UX only
    cardAccountIdentifier: string;
    thirdPartyRequiredFields: {}; // UX only
    cardProcessor: string;
    enabled: boolean;
}